/* Mint-BOD · Hiệu suất dịch vụ › Bộ phận: bar chọn bộ phận, donut tỷ trọng, bong bóng, bảng nhiệt. */
.bar { display: flex; flex-wrap: wrap; align-items: center; gap: 8px 16px; }
.bar > label { display: inline-flex; align-items: center; gap: 8px; font-size: 12px; color: var(--lb); }
.dn { display: flex; align-items: center; gap: 18px; }
.dn svg { flex-shrink: 0; }
.dnL { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 8px; }
.dnL > div { display: flex; align-items: center; gap: 8px; }
.dnL i { width: 9px; height: 9px; flex-shrink: 0; border-radius: 50%; }
.dnL span { flex: 1; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.dnL b { font-weight: var(--fw-label); }
.dnL small { width: 40px; text-align: right; font-size: 12px; color: var(--lb); }
.p0 { background: #3b9bf0; color: #3b9bf0; stroke: #3b9bf0; } /* token-ok: palette donut/bong bóng theo board */
.p1 { background: #22c55e; color: #22c55e; stroke: #22c55e; } /* token-ok: palette donut theo board */
.p2 { background: #f2a03d; color: #f2a03d; stroke: #f2a03d; } /* token-ok: palette donut theo board */
.p3 { background: #8b5cf6; color: #8b5cf6; stroke: #8b5cf6; } /* token-ok: palette donut theo board */
.p4 { background: #14b8a6; color: #14b8a6; stroke: #14b8a6; } /* token-ok: palette donut theo board */
.p5 { background: #9aa4b2; color: #9aa4b2; stroke: #9aa4b2; } /* token-ok: palette donut theo board */
.pr { background: #e5484d; color: #e5484d; stroke: #e5484d; } /* token-ok: palette biên lợi nhuận theo board */
.py { background: #fbbf24; color: #fbbf24; stroke: #fbbf24; } /* token-ok: palette biên lợi nhuận theo board */
.pb { background: #47a6f5; color: #47a6f5; stroke: #47a6f5; } /* token-ok: palette biên lợi nhuận theo board */
.sc { position: relative; width: 100%; }
.sc svg { position: absolute; inset: 0; display: block; overflow: visible; }
.sc circle { fill-opacity: 0.28; stroke-width: 1.5; }
.sc > span { position: absolute; font-size: 11px; color: var(--lb); white-space: nowrap; }
.sc > span.dl { font-weight: var(--fw-label); color: var(--tx); transform: translateY(-50%); }
.grid { fill: none; stroke: var(--line); } .quad { fill: none; stroke: var(--lb); stroke-dasharray: 4 4; }
.sub { display: block; font-size: 12px; font-weight: 400; color: var(--lb); }
.heat { display: block; margin: -6px -8px; padding: 6px 8px; }
.avgL { fill: none; stroke: #f2a03d; stroke-width: 2; } /* token-ok: đường TB mảng theo board */
.nmBtn { all: unset; cursor: pointer; font-weight: var(--fw-label); }
.nmBtn:focus-visible { outline: 2px solid var(--pri); outline-offset: 2px; }
.bar0 { fill: #3b9bf0; } /* token-ok: cột cá nhân theo board */
